import { bind, reset } from 'mousetrap';
import { forEach } from 'lodash-es';
import * as actionCreators from '../actionCreators';
import { isInAnnotationMode } from '../selectors/annotation';
export default function bindKeyboardShortcuts(store, keyboardControlsCheckerFunc) {
    var boundActionCreators = {};
    forEach(actionCreators, function (method, name) {
        boundActionCreators[name] = function () {
            if (areEnabled(keyboardControlsCheckerFunc) &&
                !isInAnnotationMode(store.getState())) {
                store.dispatch(method());
            }
        };
    });
    bind('h', boundActionCreators.showHome);
    bind('left', boundActionCreators.showPrevious);
    bind('right', boundActionCreators.showNext);
    bind('g', boundActionCreators.showGrid);
    bind('esc', boundActionCreators.hideGrid);
    bind('s', boundActionCreators.showHotspots, 'keydown');
    bind('s', boundActionCreators.hideHotspots, 'keyup');
    bind('alt', boundActionCreators.enablePercentageBasedGuidelines, 'keydown');
    bind('alt', boundActionCreators.disablePercentageBasedGuidelines, 'keyup');
    bind('-', boundActionCreators.decrementZoom);
    bind('=', boundActionCreators.incrementZoom);
    // Not all keyboard layouts have +,= together?
    bind('+', boundActionCreators.incrementZoom);
    return reset;
}
function areEnabled(keyboardControlsCheckerFunc) {
    if (!keyboardControlsCheckerFunc) {
        return true;
    }
    return keyboardControlsCheckerFunc();
}
